import { Component, OnInit } from '@angular/core';
import {AuthService} from "../../../services/auth.service";
import {DataChangeRequestService} from "../../../services/DataChangeRequest.service";
import {icJWT_Account} from "../../../NIBINInterface";
import {DownloadService} from "../../../services/download.service";

@Component({
  selector: 'app-detail-change-history',
  templateUrl: './detail-change-history.component.html',
  styleUrls: ['./detail-change-history.component.css'],
  providers:[DataChangeRequestService,DownloadService]
})
export class DetailChangeHistoryComponent implements OnInit {
  user: icJWT_Account = <icJWT_Account>{};
  constructor(private authService: AuthService,private dataChangeRequestService:DataChangeRequestService,private downloadService: DownloadService)
  {
    this.user = this.authService.getUser()
  }

  ApprovedChanges:any[] = []
  DeniedChanges:any[] = []

  ngOnInit(): void {

    //load data fn
    this.loadHistory(true).then((r)=>{console.log(this.ApprovedChanges)})
    this.loadHistory(false).then((r)=>{})
  }

  async loadHistory(approved:boolean){
    if(approved){
      let r = await this.dataChangeRequestService.GetChangeHistoryList(this.user.CurrentDept,approved)
      if(r.AnyData && r.MessageCode==200)
        this.ApprovedChanges = r.AnyData
    } else{
      let r = await this.dataChangeRequestService.GetChangeHistoryList(this.user.CurrentDept,approved)
      if(r.AnyData && r.MessageCode==200)
        this.DeniedChanges = r.AnyData
    }
  }

  PDFViewChange(IncidentID: string | null) {
    if(IncidentID)
      this.downloadService.DownloadBallisticsReport(IncidentID)
  }
}
